import { useMemo, useContext } from 'external/react'
import {TeacherContext} from 'teacher/context'
import { styled } from 'external/material';
import { subdomainLink, viewerGuard } from 'helpers/url'

const StyledDreyfousLink = styled('a')(dreyfousLinkStyles)

const DreyfousLabsLink = () => {

  const {translate, profile} = useContext(TeacherContext)

  const available = useMemo(() => profile.dreyfouslabs && profile.dreyfouslabs.length > 0, [profile.dreyfouslabs])

  if (!available) return null

  return (
    <StyledDreyfousLink {...viewerGuard({href: `${subdomainLink('dreyfouslabs', 'index.html')}?from=edusystem`, target: "_blank"})} >
      {translate('dreyfouslabs_label')}
    </StyledDreyfousLink>
  )
}

function dreyfousLinkStyles() {
  return {
  }
}

export default DreyfousLabsLink
